// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"b8-z"};